const OrderIndex = () => import('@/pages/cashier/order/OrderIndex');
const OrderDetail = () => import('@/pages/cashier/order/OrderDetail');

/**
 * Invoice route definitions
 */
export class OrderRoutes {

  constructor() {

    // define vars
    this.route_root = 'orders';
    this.type_single = 'Order';
    this.type_plural = 'Orders';

    /**
     * Define routes array
     * @type {*[]}
     */
    this.routes = [
      {
        path: this.route_root,
        name: 'List ' + this.type_plural,
        component: OrderIndex,
        meta: {requiresAuth: true}
      },
      {
        path: this.route_root + '/:id',
        name: 'View ' + this.type_single,
        component: OrderDetail,
        meta: {requiresAuth: true}
      }
    ];

    /**
     * Define public routes array
     * @type {Array}
     */
    this.public_routes = [];
  }

  /**
   * Fetch rout definitions statically
   * @returns {*[]|*}
   */
  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }

  /**
   * Fetch public routes array
   * @returns {Array}
   */
  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}

